import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { firestoreConnect, getVal } from 'react-redux-firebase'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Container, Spinner, Row, Col, Card, CardTitle, CardText} from 'reactstrap';

class Home extends Component {
  render() {
    const { auth } = this.props;
    const placeholder = [5]
    return (
        <Container className="Account text-center">
            <br/>
            <i class="fas fa-car fa-10x text-center"></i>
            <h1 className="text-center display-4"> Welcome to Caro</h1>
            <p className='lead text-center'><h3>Carpooling made Easy</h3></p>
        </Container>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
      auth: state.firebase.auth
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'global', limit: 1}
  ])
)(Home)